<template>
  <div class="EditContacts">
    <ld-header
      transparent
      v-show="showHeader"
      @click-left="onClickLeft"
    >
      <span
        v-if="id"
        slot="right"
        @click="del"
      >删除</span>
    </ld-header>
    <div :class="className">
      <mescroll-vue
        ref="mescroll"
        :down="{ use: false }"
      >
        <div class="wrap">
          <van-cell-group :title="showHeader?`${id ? '编辑' : '新增'}常用旅客`:''">
            <van-cell>
              <div style="display: flex;justify-content: space-between">
                <span><h4>姓名手机号</h4></span>
                <!--            <span><ToggleSwitch @change="handoff" /></span>-->
              </div>
            </van-cell>
            <div>
              <van-field
                v-if="!isShowLabel"
                v-model="detail.chName"
                required
                clearable
                :label="$t('D038','中文姓名')"
                placeholder="与证件保持一致"
                @blur.prevent="changeBlur"
                @input="handleInput"
              />
              <van-cell
                title="姓（拼音）"
                label="Surname"
                required
                clearable
                v-else
              >
                <!--@input="SurName"-->
                <van-field
                  clearable
                  v-model="Pinyin.surname"
                  placeholder="如 HAN"
                  @blur.prevent="changeBlur"
                  @input="SurName"
                  :error-message="errormessage(Pinyin.surname)"
                />
              </van-cell>
            </div>
            <div>
              <span
                v-if="!isShowLabel"
              />
              <van-cell
                title="名（拼音）"
                label="Given name"
                required
                clearable
                v-else
              >
                <van-field
                  clearable
                  v-model="Pinyin.name"
                  placeholder="如 MEIMEI"
                  @blur.prevent="changeBlur"
                  @input="Sname" 
                  :error-message="errormessage(Pinyin.name)"
                />
              </van-cell>
            </div>

            <van-cell
              :title="$t('D016','性别')"
              title-class="van-field__label"
              required
            >
              <van-radio
                v-model="detail.sex"
                slot="right-icon"
                name="M"
              >
                <template #icon="props">
                  <img
                    class="img-icon"
                    :src="props.checked ? activeIcon : inactiveIcon"
                  >
                </template>
                {{ $t('D018', '男') }}
              </van-radio>
              <van-radio
                v-model="detail.sex"
                slot="right-icon"
                name="F"
              >
                <template #icon="props">
                  <img
                    class="img-icon"
                    :src="props.checked ? active1 : active"
                  >
                </template>
                {{ $t('D019', '女') }}
              </van-radio>
            </van-cell>
            <van-field
              v-model="detail.phoneNumber"
              required
              clearable
              :label="$t('F008','手机号')"
              placeholder="请填写手机号"
              @blur.prevent="changeBlur"
              :error-message="phoneErrMsg"
            />
          </van-cell-group>
          <van-cell-group>
            <van-cell><h4>身份信息</h4></van-cell>
            <div class="IdentityInformation">
              <van-field
                readonly
                clickable
                name="picker"
                :value="value"
                :label="$t('D003','证件类型')"
                placeholder="请选择证件类型"
                @click="showPicker = true"
              />
              <van-popup
                v-model="showPicker"
                position="bottom"
              >
                <van-picker
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                />
              </van-popup>
              <!--身份证-->
              <div v-if="identityCard">
                <van-field
                  v-model="detail.cardNo"
                  :label="$t('D008','证件号码')"
                  placeholder="与证件保持一致"
                  required
                  clearable
                  :error-message="idNumberErrMsg"
                  @blur.prevent="changeBlur"
                />
              </div>
              <!--护照-->
              <div v-if="passport">
                <van-field
                  v-model="detail.cardNo"
                  :label="$t('D005','护照')"
                  placeholder="与证件保持一致"
                  required
                  clearable
                  @blur.prevent="changeBlur"
                />
                <van-field
                  :label="$t('D009','证件有效期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('passportPeriod')"
                  :value="detail.passportPeriod"
                />
                <van-field
                  readonly
                  clickable
                  :label="$t('D017','国籍')"
                  :value="detail.nationName"
                  placeholder="与证件保持一致"
                  required
                  @click="$refs.nation.toggle()"
                />
                <van-field
                  :label="$t('D013','出生日期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('born')"
                  :value="detail.born"
                  required
                />
              </div>
              <!--台胞证-->
              <div v-if="TaiwanPackageCertificate">
                <van-field
                  required
                  v-model="detail.cardNo"
                  :label="$t('D008','证件号码')"
                  placeholder="与证件保持一致"
                  clearable
                  @focus.prevent="changefocus"
                />
                <van-field
                  :label="$t('D009','证件有效期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('otherPeriod')"
                  :value="detail.otherPeriod"
                />
                <van-field
                  v-if="nati"
                  readonly
                  clickable
                  :label="$t('D017','国籍')"
                  :value="detail.nationName"
                  placeholder="与证件保持一致"
                  required
                  @click="$refs.nation.toggle()"
                />
                <van-field
                  :label="$t('D013','出生日期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('born')"
                  :value="detail.born"
                  required
                />
              </div>
              <!--出生证明-->
              <div v-if="BirthCertificate">
                <van-field
                  required
                  v-model="detail.cardNo"
                  :label="$t('D008','证件号码')"
                  placeholder="与证件保持一致"
                  clearable
                  @focus.prevent="changefocus"
                />
                <van-field
                  readonly
                  clickable
                  :label="$t('D017','国籍')"
                  :value="detail.nationName"
                  placeholder="与证件保持一致"
                  required
                  @click="$refs.nation.toggle()"
                />
                <van-field
                  :label="$t('D009','证件有效期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('otherPeriod')"
                  :value="detail.otherPeriod"
                />

                <van-field
                  :label="$t('D013','出生日期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('born')"
                  :value="detail.born"
                  required
                />
              </div>
              <!--港澳台-->
              <div v-if="HongKongMacaoAndTaiwan">
                <van-field
                  required
                  v-model="detail.cardNo"
                  :label="$t('D008','证件号码')"
                  placeholder="与证件保持一致"
                  clearable
                  @focus.prevent="changefocus"
                />
                <van-field
                  :label="$t('D009','证件有效期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('otherPeriod')"
                  :value="detail.cardNo"
                />
                <van-field
                  :label="$t('D013','出生日期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('born')"
                  :value="detail.born"
                  required
                />
              </div>
            </div>
          </van-cell-group>
          <div class="font12 gray wrap">
            如需完善员工详细资料，请联系管理员进行处理
          </div>
          <ld-nation
            ref="nation"
            @selected="nationSelect"
          />
          <div class="submit-btn__wrap">
            <ld-button
              @click="save"
              main3
              size="lg"
            >
              {{ $t('B010', '保存') }}
            </ld-button>
          </div>
        </div>
      </mescroll-vue>
    </div>

    <van-popup
      v-model="dateShow"
      position="bottom"
      :close-on-popstate="true"
      :style="{ height: '40%' }"
    >
      <van-datetime-picker
        v-model="datepickModel"
        @confirm="datePickerConfirm"
        @cancel="dateShow = false"
        :min-date="minDate"
        type="date"
      />
    </van-popup>
  </div>
</template>

<script>
import {Cell, CellGroup, DatetimePicker, Field, Form, Picker, Popup, Radio, Switch} from 'vant'
import ldButton from 'Common/ldButton'
import contactsInteractor from 'Domain/use-cases/contacts-interactor'
import {validators} from 'Utils/valid'
import {formatDate} from 'Utils/dateUtil'
import {changeBlur, changefocus} from 'Utils/tools'
import {excludeSpecial} from 'Utils/string'
import {getIDcardInfo} from 'Utils/publicFun'
import ToggleSwitch from 'Views/Home/userCenter/CommonInfo/switch.vue'
import tabman from 'Assets/images/user/man.png'
import tabman1 from 'Assets/images/user/man1.png'
import woman from 'Assets/images/user/woman.png'
import woman1 from 'Assets/images/user/woman1.png'
import pinyin from 'js-pinyin'
import ldNation from 'Components/ldNation'
import { jsGetAgeaccurate,extractBirthdate,typeage } from 'Utils/dateUtil'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  name: 'EditContacts',
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Form.name]: Form,
    [Picker.name]: Picker,
    [Switch.name]: Switch,
    ldButton,
    ToggleSwitch,
    pinyin,
    ldNation,
    MescrollVue,
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    cplx: {//产品类型
      type: [String, Number],
      default: '',
    },
    className: {
      type: String,
      default: 'wrapper'
    },
  },
  data() {
    return {
      nati: false,
      radio: '1',
      activeIcon: tabman1,
      inactiveIcon: tabman,
      active: woman,
      active1: woman1,
      isShowLabel: false,
      checked: true,
      HongKongMacaoAndTaiwan: false,//港澳台
      BirthCertificate: false,//出生证明
      TaiwanPackageCertificate: false,//台胞证
      identityCard: true,//身份证
      passport: false,//护照
      nationId: '', // (string): 国籍 ,
      nationName: '', // (string): 国籍 ,
      value: '身份证',
      columns: ['身份证', '护照', '台胞证', '回乡证', '户口簿', '出生证明', '海员', '军人', '港澳台通行', '台湾通行证', '外国人永久居留证', '港澳台居民居住证'],
      showPicker: false,
      Pinyin: {
        surname: '',
        name: '',
        Pinyinz: '',
      },
      detail: {
        sex: 'M',
        psgType: '',
        nation: '',
        nationName: '',
        chName: '',
        enName: '',
        cardType: '',
      },
      minDate: new Date('1900-01-01'),
      datepickModel: new Date(),
      currentCheckBorn: '',
      phoneErrMsg: '',
      idNumberErrMsg: '',
      dateShow: false,
      regex:"/^[a-zA-Z]+$/"
    }
  },
  async created() {
    if (this.id) this.query()
    if (this.cplx == '10902') {
      this.onConfirm('护照', 1)
    }
    if (this.value == '身份证') {
      this.detail.nation = '00002'
      this.detail.cardType = 'NI'
    }
  },
  methods: {
    errormessage(val){
      if(val){
        const regex = /^[a-zA-Z]+$/;
        if(!regex.test(val)){
          return "请以英文输入,勿含空格或其他特殊字符"
        }
      }else{
        return ''
      }
    },
    handleInput(event) {
      let pinyin = require('js-pinyin')
      pinyin.setOptions({checkPolyphone: false, charCase: 0})
      const lastName = pinyin.getFullChars(event.substring(0, 1)) // 取姓
      const firstName = pinyin.getFullChars(event.substring(1)) // 取名
      this.Pinyin.surname = lastName
      this.Pinyin.name = firstName
      this.Pinyin.Pinyinz = this.detail.empName
      this.detail.chName = event || ''
      this.detail.enName = this.Pinyin.surname + '/' + this.Pinyin.name
    },
    SurName(event) {
      // this.Pinyin.surname = event.replace(/[^a-zA-Z]/g, '')
      this.Pinyin.surname = this.Pinyin.surname.toUpperCase()
    },
    Sname(event) {
      // this.Pinyin.name = event.replace(/[^a-zA-Z]/g, '')
      this.Pinyin.name = this.Pinyin.name.toUpperCase()
      this.detail.enName = this.Pinyin.surname + '/' + this.Pinyin.name
      this.detail.chName = this.Pinyin.surname + '/' + this.Pinyin.name
    },
    handoff() {
      console.log('qiehuan ')
      this.isShowLabel = !this.isShowLabel
    },
    onClickLeft() {
      this.$router.go(-1)
      this.$i18n.set('zh-CN')
    },
    // 证件类型选择
    onConfirm(value, key) {
      this.value = value
      this.showPicker = false
      if (key == '0') {
        this.identityCard = true//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.isShowLabel = false//切换拼音
        this.detail.cardType = 'NI'//身份证
        this.detail.empName = this.detail.empName
        this.detail.cardName = '身份证'
      } else if (key == '1') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.identityCard = false//身份证
        this.passport = true//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'PP'//身份证
        this.detail.cardName = '护照'
      } else if (key == '2') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证-回乡证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'TB'//身份证
        this.detail.cardName = '台胞'
      } else if (key == '3') {
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证-回乡证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'HX'//身份证
        this.detail.cardName = '回乡'
      } else if (key == '4') {
        this.isShowLabel = false//切换拼音
        this.identityCard = true//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.chName = this.detail.empName
        this.detail.cardType = 'HR'//身份证
        this.detail.cardName = '户口簿'
      } else if (key == '5') {
        this.isShowLabel = false//切换拼音
        this.BirthCertificate = true//出生证明
        this.identityCard = false//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'BC'//身份证
        this.detail.cardName = '出生证明'
      } else if (key == '6') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'HY'//身份证
        this.detail.cardName = '海员'
        console.log('海员')
      } else if (key == '7') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'JR'//身份证
        this.detail.cardName = '军人'
        console.log('军人')
      } else if (key == '8') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'GA'//身份证
        this.detail.cardName = '港澳台通行'
        console.log('港澳台通行')
      } else if (key == '9') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'TW'//身份证
        this.detail.cardName = '台湾通行证'
        console.log('台湾通行证')
      } else if (key == '10') {
        this.detail.chName = ''
        this.nati = true
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'FI'//身份证
        this.detail.cardName = '外国人永久居留证'
        console.log('外国人永久居留证')
      } else if (key == '11') {
        this.isShowLabel = true//切换拼音
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.BirthCertificate = false//出生证明
        this.identityCard = false//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = true//台胞证
        this.detail.cardType = 'HM'//身份证
        this.detail.cardName = '港澳合居民居住证'
      }
      this.Pinyin.surname = this.detail.enName.split('/')[0]
      this.Pinyin.name = this.detail.enName.split('/')[1]
      this.detail.chName = this.detail.chName
    },
    nationSelect(nation) {
      this.$set(this.detail, 'nation', nation.id)
      this.$set(this.detail, 'nationName', nation.cName)
    },
    changeBlur, changefocus,
    dateShowAction(row) {
      if (row == 'born') {
        this.currentCheckBorn = row
        this.datepickModel = this.detail[this.currentCheckBorn]
          ? new Date(this.detail[this.currentCheckBorn])
          : new Date()
        this.dateShow = true
      } else {
        this.currentCheckBorn = 'otherPeriod'
        this.datepickModel = this.detail[this.currentCheckBorn]
          ? new Date(this.detail[this.currentCheckBorn])
          : new Date()
        this.dateShow = true
      }

    },
    datePickerConfirm(date) {
      if (this.currentCheckBorn == 'otherPeriod') {
        this.detail[this.currentCheckBorn] = formatDate(date).date
        this.detail.passportPeriod = this.detail[this.currentCheckBorn]
        this.detail.otherPeriod = this.detail[this.currentCheckBorn]
        this.dateShow = false
        const ageCategory = calculateAgeCategory(formatDate(date).date)
        console.log(ageCategory, '000')
      } else {
        this.detail[this.currentCheckBorn] = formatDate(date).date
        this.dateShow = false
        const ageCategory = calculateAgeCategory(formatDate(date).date)
        console.log(ageCategory) // 输出：儿童
        if (ageCategory == 1) {
          this.detail.psgType = 1
        } else if (ageCategory == 2) {
          this.detail.psgType = 2
        } else if (ageCategory == 3) {
          this.detail.psgType = 3
        }
      }
    },
    async query() {
      let {data} = await contactsInteractor.getContactsById(this.id)
      this.detail = data
    },
    async save() {
      console.log('this.detail', this.detail, this)
      if (!this.detail.cardNo) {
        this.$validErrorTips('证件号码不能为空')
      } else if (!this.detail.sex) {
        this.$validErrorTips('性别不能为空')
      } else if (!this.detail.phoneNumber) {
        this.$validErrorTips('手机号不能为空')
      } else if (this.detail.cardType == "NI" && !validators['is-idCard'](this.detail.cardNo).valid) {
        this.$toast('请输入有效身份证信息')
        return
      } else {
        if(this.detail.cardType == 'NI' && this.detail.chName) {//身份证
          let letters = /[a-zA-Z]/.test(this.detail.chName);
          if (letters) {
            this.$toast('身份证姓名不能包含字母')
            return
          }
        }
        //姓字是中英文的
        let other=['护照','台胞','回乡','户口簿','出生证明','海员','军人','港澳台通行','港澳合居民居住证']
        if(other.includes(this.detail.cardName)){
          const regex1=/^[A-Za-z]+$/
          if(!regex1.test(this.Pinyin.surname) || !regex1.test(this.Pinyin.name)){
            this.$toast('请正确输入姓名')
            return
          }
          const regex = /^[A-Za-z\\/]+$/;
          if(!regex.test(this.detail.chName)){
            this.$toast('请正确输入姓名')
            return
          }
        }
        if(this.detail.cardType == ("NI" || 'HR')) {//提取身份证出生年月日
          this.detail.born = extractBirthdate(this.detail.cardNo)
        }
        let age = jsGetAgeaccurate(this.detail.born)//计算年龄
        this.detail.psgType = typeage(age)//计算出类型
        //判断姓名中是否有点
        if(this.detail.chName &&  this.detail.chName.includes('·')) {
          this.detail.chName = this.detail.chName.split('·').join('');
        }
        await contactsInteractor.saveContacts(this.detail)
        this.$toast("保存成功")
        setTimeout(() => {
          if (this.id == 0) {
            this.detail = {};
          }
          this.back();
        }, 1000);
      }
    },
    /**
     * 删除常旅客
     */
    del() {
      this.$dialog.confirm({
        message: '确定删除吗？'
      }).then(async () => {
        await contactsInteractor.deleteContacts(this.id)
        this.$dialog({message: '删除成功！'}).then(() => {
          this.back()
        })
      })
    },
    back() {
      if (this.showHeader) {
        this.$router.go(-1)
      } else {
        this.$emit('call-back', false)
      }
    }
  },
  watch: {
    'detail.phoneNumber': function (val) {
      this.detail.phoneNumber = excludeSpecial(val)
      if (!validators.mobile(val).valid) {
        this.phoneErrMsg = validators.mobile(val).msg
      } else {
        this.phoneErrMsg = ''
      }
    },
    'detail.idNumber': function (val) {
      this.detail.cardNo = excludeSpecial(val)
      if (val && !validators['is-idCard'](val).valid) {
        this.idNumberErrMsg = validators['is-idCard'](val).msg
      } else {
        this.idNumberErrMsg = ''
      }
      if (!this.detail.born && this.detail.cardNo && !this.idNumberErrMsg) {
        this.detail.born = getIDcardInfo(this.detail.cardNo).born
      }
      const reg =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (reg.test(this.detail.cardNo)) {
        var org_birthday = this.detail.cardNo.substring(6, 14)
        var org_gender = this.detail.cardNo.substring(16, 17)
        var sex = org_gender % 2 == 1 ? '男' : '女'
        console.log(sex, 'org_gender')
        var birthday =
          org_birthday.substring(0, 4) +
          '-' +
          org_birthday.substring(4, 6) +
          '-' +
          org_birthday.substring(6, 8)
        var birthdays = new Date(birthday.replace(/-/g, '/'))
        let d = new Date()
        let age =
          d.getFullYear() -
          birthdays.getFullYear() -
          (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate()) ? 1 : 0)
        if (age >= 1 && age <= 2) {
          this.detail.psgType = 3
        } else if (age >= 6 && age <= 12) {
          this.detail.psgType = 2
        } else if (age >= 18 && age <= 40) {
          this.detail.psgType = 1
        }
      } else {
        this.detail.psgType = 1
        return false
      }
      console.log('thos', this)

    }
  }

}

function calculateAgeCategory(birthdate) {
  const today = new Date()
  const birthdateArr = birthdate.split('-')
  const birthYear = parseInt(birthdateArr[0])
  const birthMonth = parseInt(birthdateArr[1]) - 1
  const birthDay = parseInt(birthdateArr[2])

  const birthdateObj = new Date(birthYear, birthMonth, birthDay)
  let age = today.getFullYear() - birthdateObj.getFullYear()

  // 检查生日是否已经过了，如果生日还未到，则年龄减一
  const hasPassedBirthday = today.getMonth() > birthdateObj.getMonth() ||
    (today.getMonth() === birthdateObj.getMonth() && today.getDate() >= birthdateObj.getDate())
  if (!hasPassedBirthday) {
    age--
  }
  // 判断年龄类别
  if (age >= 18) {
    return '1'
  } else if (age >= 12) {
    return '1'
  } else if (age >= 1) {
    return '2'
  } else {
    return '3'
  }
}
</script>

<style lang="less" scoped>
.EditContacts {
  h4 {
    margin: 0;
  }

  .wrap {
    padding: 10px 6px;
  }

  .submit-btn__wrap {
    padding: 0 37px;
    margin: 0 auto 10px;
  }

  .van-cell-group__title {
    padding-top: 0;
    font-size: @font-size-20;
    letter-spacing: 1px;
    color: @color-text-black;
  }

  .van-cell-group {
    margin-top: 5px;
  }

  .van-cell__title + .van-radio {
    padding-right: 20px;
  }
  .wrapper {
    height: calc(100vh - 46px);
    overflow: hidden;
  }
  .wrapper1 {
    height: calc(100vh - 100px);
    overflow: hidden;
  }

}

.IdentityInformation {
  width: 100%;
  height: 100%;
}

//.van-switch:before{
//  content:"英";
//  z-index: 5;
//  font-size:18px;
//}
//.van-switch--on:before{nan
//  content:"中";
//  z-index: 5;
//  font-size:18px;
//  padding: 0 26px 0 0px;
//}
.van-cell__title {
  flex: 0.3;
}

.img-icon {
  height: 20px;
}
</style>

